import React, {useCallback, useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import {Dialog, DialogContent, IconButton, Typography} from "@material-ui/core"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import CloseIcon from "@material-ui/icons/Close"
import {useDispatch, useStore} from "../Store"
import "../i18n"
import CandleChart from "./CandleChart"
import {makeStyles} from "@material-ui/core/styles"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import Pagination from "@material-ui/lab/Pagination"
import {useTheme} from "../hooks"

const useStyles = makeStyles((theme) => ({
  root: {
    height: `100vh`,
  },
  title: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: `absolute`,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  pager: {
    "& > *": {
      margin: `0 auto`,
      textAlign: `center`,
      width: `100%`,
      marginTop: theme.spacing(2),
    },
  },
}))

export default function RankingDialog() {
  const {t} = useTranslation()
  const {
    store: {
      perspective,
      inputCompareList,
      sectionLength,
      normPage,
      rankingPanel,
      rankingPage,
      themeColor,
    },
  } = useStore()
  const theme = useTheme(themeColor)
  const isMobile = useMediaQuery(theme.breakpoints.down(`xs`))
  const classes = useStyles({
    isMobile,
  })
  const {dispatch} = useDispatch()
  const [closing, setClosing] = useState(false)

  const handleChange = (event, value) => {
    dispatch({
      type: `RANKING_PAGE`,
      rankingPage: value,
    })
  }
  const fullScreen = useMediaQuery(theme.breakpoints.down(`xs`))

  const DialogTitle = (props) => {
    const {title, classes, onClose} = props
    return (
      <MuiDialogTitle disableTypography className={classes.title}>
        <Typography align={`center`} variant="h5">
          {title}
        </Typography>
        {onClose ? (
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    )
  }

  /** ランキング入り銘柄数 */
  const rankingPageCount = () => {
    return (inputCompareList[perspective]?.length ?? 0) - 1
  }

  /** ランキング入り銘柄ページタイトル */
  const rankingTitle = () => {
    return t(`rankingTitle`).replace(`@`, rankingPageCount())
  }

  const handleClose = useCallback(() => {
    setClosing(true)
    setTimeout(
      () =>
        dispatch({
          type: `RANKING_PANEL`,
          rankingPanel: false,
        }),
      100,
    )
  }, [])

  useEffect(() => {
    setClosing(false)
  }, [rankingPanel])

  return (
    <Dialog
      className={classes.root}
      fullWidth
      maxWidth={`xl`}
      fullScreen={fullScreen}
      open={rankingPanel}
      onClose={handleClose}
    >
      <DialogTitle classes={classes} title={rankingTitle()} onClose={handleClose} />
      <DialogContent>
        <CandleChart id={`rankingChart`} closing={closing} isDialog={true} />
        <div className={classes.pager}>
          <Pagination
            count={rankingPageCount()}
            variant="outlined"
            siblingCount={isMobile ? 0 : 5}
            boundaryCount={2}
            page={rankingPage}
            onChange={handleChange}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
